import SpaceQuest from './components/SpaceQuest/SpaceQuest';

export default function App() {
  return <SpaceQuest />;
}
